import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect, tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { serverRoleByDurationCurrency, serverRoleByDuration } from "@/api/dataAll/userSegmentationGrowth";
import { mapState } from 'vuex';
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "serverRoleTieredOnline",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      tableData: [],
      tableList: [],
      serverList: [],
      characterList: [{
        label: this.$t('characterSword'),
        value: 1
      }, {
        label: this.$t('characterThunder'),
        value: 2
      }, {
        label: this.$t('characterIce'),
        value: 3
      }]
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    levelChange: function levelChange(e) {
      if (!e) {
        this.paramsData.recharge_levels = '';
      }
    },
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    searchClick: function searchClick() {
      var _this2 = this;

      this.tableList = [];
      this.tableData = [];

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      if (this.levelItem == '1' && !this.paramsData.recharge_levels) {
        this.$message.error(this.$t('pleaseInputLevel'));
        return;
      }

      if (/，/.test(this.paramsData.recharge_levels)) {
        this.$message.error(this.$t('pleaseInputEnglishComma'));
        return;
      }

      if (this.paramsData.server_id.length == 0) {
        this.$message.error(this.$t('pleaseSelectServer'));
        return;
      }

      this.reqLoading = true;
      var params = {
        game_id: this.searchData.game_id,
        special_product_id: this.searchData.special_product_id,
        starttime: this.searchData.starttime,
        endtime: this.searchData.endtime,
        server_id: this.paramsData.server_id,
        ad_channel: this.searchData.ad_channel,
        ad_placement: this.searchData.ad_placement,
        recharge_levels: this.paramsData.recharge_levels,
        character_id: this.paramsData.character_id
      };
      var searchCurrency = this.$store.state.d2admin.serchSelect.searchCurrency;
      var reqFn = searchCurrency.length ? serverRoleByDurationCurrency : serverRoleByDuration;
      reqFn(params).then(function (res) {
        if (res.code == 200) {
          var data = res.data;
          var statusArr = []; //处理表头

          for (var i in data) {
            for (var j in data[i]["avg_duration"]) {
              statusArr.push(j);
            }

            break;
          }

          statusArr.forEach(function (item) {
            _this2.tableList.push({
              label: item,
              prop: item
            });
          });

          for (var _i in data) {
            _this2.tableData.push(_objectSpread(_objectSpread({}, data[_i]["avg_duration"]), {}, {
              level_amount: data[_i]["range"],
              new_count: data[_i]["new_count"]
            }));
          }

          _this2.tableList.unshift({
            label: _this2.$t('payAmount'),
            prop: 'level_amount',
            desc: _this2.$t('payAmountRangeDesc')
          }, {
            label: _this2.$t('newPayPeopleCount'),
            prop: 'new_count'
          });
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      var columns = [];
      var d = {};
      this.tableList.forEach(function (item, index) {
        columns.push({
          label: item.label,
          prop: item.prop
        });
      });
      var data = JSON.parse(JSON.stringify(this.tableData));
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};